import React from 'react';
import { BsTwitter, BsFacebook, BsLinkedin } from 'react-icons/bs';
import { FaClock, FaEye, FaShare } from 'react-icons/fa';
import { format } from 'date-fns';
import StatusBadge from '../../common/StatusBadge';

const ContentDetail = ({ page }) => {
  if (!page) return <div>Loading...</div>;

  const handleShare = async (platform) => {
    const url = window.location.href;
    const title = page.title;
    let shareUrl = '';

    switch (platform) {
      case 'twitter':
        shareUrl = `https://twitter.com/share?url=${url}&text=${title}`;
        break;
      case 'facebook':
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
        break;
      case 'linkedin':
        shareUrl = `https://www.linkedin.com/shareArticle?url=${url}&title=${title}`;
        break;
      default:
        return;
    }

    window.open(shareUrl, '_blank', 'width=600,height=400');
  };

  return (
    <div className="container mx-auto py-8">
      {/* Full Width Feature Image with Overlay Title */}
      <div className="relative w-full h-96 mb-8">
        {page.featureImage && (
          <img
            src={page.featureImage}
            alt={page.title}
            className="w-full h-full object-cover"
          />
        )}
        <div className="absolute inset-0 bg-black bg-opacity-40 flex flex-col justify-center items-center text-white p-4">
          <h1 className="text-5xl font-bold text-center">{page.title}</h1>
          <div className="flex items-center space-x-4 mt-4">
            <span className="flex items-center">
              <FaClock className="mr-2" />
              {format(new Date(page.updatedAt || page.createdAt), 'MMM d, yyyy')}
            </span>
            <span className="flex items-center">
              <FaEye className="mr-2" />
              {page.views || 0} views
            </span>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto">
        {/* Social Share Buttons */}
        <div className="flex justify-center space-x-4 mb-8">
          <button onClick={() => handleShare('twitter')} className="text-blue-500 hover:text-blue-600">
            <BsTwitter size={24} />
          </button>
          <button onClick={() => handleShare('facebook')} className="text-blue-800 hover:text-blue-900">
            <BsFacebook size={24} />
          </button>
          <button onClick={() => handleShare('linkedin')} className="text-blue-600 hover:text-blue-700">
            <BsLinkedin size={24} />
          </button>
          <button onClick={() => handleShare('share')} className="text-gray-600 hover:text-gray-700">
            <FaShare size={24} />
          </button>
        </div>

        {/* Meta Information */}
        <div className="flex items-center justify-between text-sm text-gray-500 mb-6">
          <div className="flex items-center space-x-4">
            <span>Last Updated: {format(new Date(page.updatedAt || page.createdAt), 'MMM d, yyyy')}</span>
            <StatusBadge status={page.status} />
          </div>
        </div>

        {/* Short Description */}
        {page.shortDescription && (
          <div className="text-lg text-gray-600 dark:text-gray-400 italic mb-8">
            {page.shortDescription}
          </div>
        )}

        {/* Main Content */}
        <div className="prose prose-lg max-w-none dark:prose-invert">
          <div dangerouslySetInnerHTML={{ __html: page.content }} />
        </div>

        {/* Meta Description */}
        {page.metaDescription && (
          <div className="mt-8 p-4 bg-gray-50 dark:bg-gray-700 rounded-lg">
            <p className="text-sm text-gray-600 dark:text-gray-400">
              {page.metaDescription}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContentDetail; 